module.exports = __webpack_public_path__ + "img/logo_zapotlan.589a4f88.png";